import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Footer.css';

const HIDDEN_FOOTER_PREFIXES = ['/ev', '/events', '/profile'];

const Footer: React.FC = () => {
  const { pathname } = useLocation();
  const isProductRoute = HIDDEN_FOOTER_PREFIXES.some((prefix) => pathname.startsWith(prefix));

  if (isProductRoute) {
    return null;
  }

  return (
    <footer className="site-footer">
      <div className="container site-footer__inner">
        <div className="site-footer__brand">
          <Link to="/" className="site-footer__logo" aria-label="Pikm home">
            <span className="site-footer__logo-icon">PK</span>
            <span>PIKM</span>
          </Link>
        </div>
        <nav className="site-footer__nav" aria-label="Footer navigation">
          <Link to="/">Home</Link>
          <Link to="/#pricing">Pricing</Link>
          <Link to="/login">Log in</Link>
          <Link to="/onboarding">Sign up</Link>
        </nav>
      </div>
    </footer>
  );
};

export default Footer;
